module.exports = __webpack_public_path__ + "static/media/bee-artwork.3b06283c.png";